require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./feature-all-eyes-on-us.json") })
        }
      }, "path---feature-all-eyes-on-us");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---feature-all-eyes-on-us!./.cache/json/feature-all-eyes-on-us.json
// module id = 633
// module chunks = 231608221292675